// src/redux/reducers/cityReducer.js
import {
    FETCH_JOB_TITLE_REQUEST,
    FETCH_JOB_TITLE_SUCCESS,
    FETCH_JOB_TITLE_FAILURE,
    SET_SELECTED_JOB_TITLE,
} from '../types';

const initialState = {
    loading: false,
    jobTitleList: [],
    selectedJobTitleId: null,
    error: null,
};

const jobTitleReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_JOB_TITLE_REQUEST:
            return { ...state, loading: true };
        case FETCH_JOB_TITLE_SUCCESS:
            return { ...state, loading: false, jobTitleList: action.payload };
        case FETCH_JOB_TITLE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_SELECTED_JOB_TITLE:
            return { ...state, selectedJobTitleId: action.payload };
        default:
            return state;
    }
};

export default jobTitleReducer;
